import { downloadTransactions } from './downloadTransactions';
import { fetchGourmetTransactions } from './fetchGourmetTransactions';
import { fetchExpiringCreditTransactions } from './fetchExpiringCreditTransactions';
import { fetchGroceryTransactions } from './fetchGroceryTransactions';
import { fetchRideTransactions } from './fetchRideTransactions';
import { fetchTransaction } from './fetchTransaction';
import { fetchTransactions } from './fetchTransactions';

export const transactionService = {
  downloadTransactions,
  fetchGourmetTransactions,
  fetchExpiringCreditTransactions,
  fetchGroceryTransactions,
  fetchRideTransactions,
  fetchTransaction,
  fetchTransactions,
};
